import { TablePropertiesSidePanel } from "PFApp/components/table_properties/table_properties_side_panel";

import { useInterestedContext } from "./interested_context";

const PropertiesPanel = () => {
  const { columns, showTableProperties, setTablePropertiesVisibility, selectedColumns, setSelectedColumns } =
    useInterestedContext();

  return (
    <TablePropertiesSidePanel
      onCloseClick={() => setTablePropertiesVisibility(false)}
      onColumnsChange={setSelectedColumns}
      isVisible={showTableProperties}
      availableColumns={columns}
      selectedColumns={selectedColumns}
    />
  );
};

export default PropertiesPanel;
